var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:_vm.fluid? 'w-100':'',attrs:{"src":_vm.srcUrl},on:{"error":_vm.replaceByDefault}})])}
var staticRenderFns = []

export { render, staticRenderFns }